/* Jwear gift box launcher + Klaviyo signup popup (snippets/jw-gift-box.liquid). */
(function () {
  'use strict';

  if (window.__jwGiftBox) return;
  window.__jwGiftBox = true;

  var STORAGE_DISMISSED = 'jw_gift_box_dismissed_until';
  var STORAGE_SIGNED_UP = 'jw_gift_box_signed_up';
  var SHOW_DELAY_MS = 1200;
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  var root = document.querySelector('[data-jw-gift]');
  if (!root) return;

  var launcher = root.querySelector('[data-jw-gift-launcher]');
  var openBtn = root.querySelector('[data-jw-gift-open]');
  var dismissBtn = root.querySelector('[data-jw-gift-dismiss]');
  var modal = root.querySelector('[data-jw-gift-modal]');
  var dialog = root.querySelector('[data-jw-gift-dialog]');
  var form = root.querySelector('[data-jw-gift-form]');
  var emailInput = root.querySelector('[data-jw-gift-email]');
  var submitBtn = root.querySelector('[data-jw-gift-submit]');
  var statusEl = root.querySelector('[data-jw-gift-status]');
  var formView = root.querySelector('[data-jw-gift-view="form"]');
  var successView = root.querySelector('[data-jw-gift-view="success"]');
  var copyBtn = root.querySelector('[data-jw-gift-copy]');
  var codeEl = root.querySelector('[data-jw-gift-code]');

  var siteId = (root.getAttribute('data-site-id') || '').trim();
  var listId = (root.getAttribute('data-list-id') || '').trim();
  var dismissDays = parseInt(root.getAttribute('data-dismiss-days'), 10) || 7;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  var lastFocus = null;
  var submitting = false;

  if (root.hasAttribute('data-key-error')) {
    console.error(
      '[jw-gift-box] A private Klaviyo API key was pasted into "Klaviyo public site ID". It was not output. ' +
        'Use the 6-character public site ID instead and rotate the private key in Klaviyo.'
    );
  }

  /* ------------------------------------------------------------------ */
  /* Storage                                                            */
  /* ------------------------------------------------------------------ */

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {}
  }

  function lead() {
    return window.JwLead || null;
  }

  function isSuppressed() {
    if (storageGet(STORAGE_SIGNED_UP) === '1') return true;
    var api = lead();
    if (api && api.giftBoxSignedUp && api.giftBoxSignedUp()) return true;
    if (api && siteId && listId && api.getEmail() && api.isSubscribed(api.getEmail(), listId)) return true;
    var until = parseInt(storageGet(STORAGE_DISMISSED), 10);
    return !isNaN(until) && until > Date.now();
  }

  /* ------------------------------------------------------------------ */
  /* Launcher show / hide (bottom offset via jw-fab-stack.js)           */
  /* ------------------------------------------------------------------ */

  function requestStack() {
    if (window.JwFabStack && typeof window.JwFabStack.request === 'function') {
      window.JwFabStack.request();
    } else if (window.JwFabStack && typeof window.JwFabStack.refresh === 'function') {
      window.JwFabStack.refresh();
    }
  }

  function showLauncher() {
    launcher.hidden = false;
    requestStack();
    if (reducedMotion.matches) {
      launcher.classList.add('is-idle');
      return;
    }
    launcher.classList.add('is-in');
    launcher.addEventListener(
      'animationend',
      function () {
        launcher.classList.remove('is-in');
        launcher.classList.add('is-idle');
        requestStack();
      },
      { once: true }
    );
  }

  function hideLauncher() {
    if (!launcher || launcher.hidden) return;
    launcher.classList.remove('is-in', 'is-idle');
    launcher.classList.add('is-out');
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      launcher.hidden = true;
      launcher.classList.remove('is-out');
      requestStack();
    }
    launcher.addEventListener('animationend', finish, { once: true });
    window.setTimeout(finish, reducedMotion.matches ? 0 : 450);
  }

  /* ------------------------------------------------------------------ */
  /* Modal                                                              */
  /* ------------------------------------------------------------------ */

  function focusables() {
    return Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  function onKeydown(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      closeModal();
      return;
    }
    if (event.key !== 'Tab') return;
    var items = focusables();
    if (!items.length) {
      event.preventDefault();
      dialog.focus();
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (event.shiftKey && (active === first || !dialog.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !dialog.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  }

  function openModal() {
    if (!modal.hidden && !modal.classList.contains('is-closing')) return;
    lastFocus = document.activeElement;
    modal.classList.remove('is-closing');
    modal.hidden = false;
    root.classList.add('is-modal-open');
    document.documentElement.classList.add('jw-gift-scroll-lock');
    openBtn.setAttribute('aria-expanded', 'true');
    void modal.offsetWidth;
    modal.classList.add('is-open');
    document.addEventListener('keydown', onKeydown, true);
    requestStack();

    var target = successView && !successView.hidden ? successView.querySelector('[data-jw-gift-success-title]') : null;
    target = target || form.querySelector('input') || dialog;
    window.setTimeout(function () {
      target.focus({ preventScroll: true });
    }, 30);
  }

  function closeModal() {
    if (modal.hidden || modal.classList.contains('is-closing')) return;
    document.removeEventListener('keydown', onKeydown, true);
    modal.classList.remove('is-open');
    modal.classList.add('is-closing');
    openBtn.setAttribute('aria-expanded', 'false');

    var done = false;
    function finish() {
      if (done) return;
      done = true;
      modal.hidden = true;
      modal.classList.remove('is-closing');
      root.classList.remove('is-modal-open');
      document.documentElement.classList.remove('jw-gift-scroll-lock');
      requestStack();
      var back = !launcher.hidden ? openBtn : lastFocus;
      if (back && typeof back.focus === 'function' && document.contains(back)) {
        back.focus({ preventScroll: true });
      }
      if (storageGet(STORAGE_SIGNED_UP) === '1') hideLauncher();
    }
    dialog.addEventListener('animationend', finish, { once: true });
    window.setTimeout(finish, reducedMotion.matches ? 0 : 300);
  }

  /* ------------------------------------------------------------------ */
  /* Klaviyo signup                                                     */
  /* ------------------------------------------------------------------ */

  function setStatus(message, isError) {
    statusEl.textContent = message || '';
    statusEl.classList.toggle('is-error', !!isError);
  }

  function setBusy(busy) {
    submitting = busy;
    submitBtn.disabled = busy;
    submitBtn.setAttribute('aria-busy', busy ? 'true' : 'false');
    if (busy) {
      submitBtn.setAttribute('data-label', submitBtn.textContent);
      submitBtn.textContent = 'Sending…';
    } else if (submitBtn.hasAttribute('data-label')) {
      submitBtn.textContent = submitBtn.getAttribute('data-label');
    }
  }

  function configIsValid() {
    var missing = [];
    if (!siteId) missing.push('Klaviyo public site ID');
    if (!listId) missing.push('Klaviyo list ID');
    if (missing.length) {
      console.warn(
        '[jw-gift-box] Signup disabled: missing ' +
          missing.join(' and ') +
          '. Set them in Theme settings > Gift box popup.'
      );
      return false;
    }
    if (/^pk_/i.test(siteId) || !/^[A-Za-z0-9]{6}$/.test(siteId)) {
      console.warn('[jw-gift-box] Signup disabled: "' + siteId + '" is not a 6-character Klaviyo public site ID.');
      return false;
    }
    return true;
  }

  function showSuccess() {
    storageSet(STORAGE_SIGNED_UP, '1');
    formView.hidden = true;
    successView.hidden = false;
    var title = successView.querySelector('[data-jw-gift-success-title]');
    if (title) title.focus({ preventScroll: true });
    try {
      document.dispatchEvent(new CustomEvent('jw:gift-box:subscribed'));
    } catch (e) {}
  }

  function onSubmit(event) {
    event.preventDefault();
    if (submitting) return;

    var api = lead();
    var email = api ? api.normalize(emailInput.value) : (emailInput.value || '').trim().toLowerCase();
    emailInput.value = email;
    var valid = api ? api.isValid(email) : !!(email && emailInput.checkValidity());
    if (!valid) {
      emailInput.setAttribute('aria-invalid', 'true');
      setStatus('Please enter a valid email address.', true);
      emailInput.focus();
      return;
    }
    emailInput.removeAttribute('aria-invalid');

    if (!configIsValid()) {
      setStatus('Signup is not available right now. Please try again later.', true);
      return;
    }

    setBusy(true);
    setStatus('');

    var request = api
      ? api.subscribe({ email: email, siteId: siteId, listId: listId, source: 'Jwear gift box popup' })
      : Promise.resolve({ status: 'disabled' });

    request
      .then(function (result) {
        setBusy(false);
        if (result && (result.status === 'sent' || result.status === 'skipped')) {
          showSuccess();
          return;
        }
        if (result && result.status === 'disabled') {
          setStatus('Signup is not available right now. Please try again later.', true);
          return;
        }
        setStatus('Something went wrong. Please check your email and try again.', true);
      })
      .catch(function (error) {
        setBusy(false);
        console.warn('[jw-gift-box] Klaviyo subscription failed.', error);
        setStatus('Something went wrong. Please check your email and try again.', true);
      });
  }

  function onCopy() {
    if (!codeEl) return;
    var code = codeEl.textContent.trim();
    var done = function () {
      copyBtn.textContent = 'Copied';
      window.setTimeout(function () {
        copyBtn.textContent = 'Copy';
      }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, function () {});
    } else {
      var range = document.createRange();
      range.selectNodeContents(codeEl);
      var selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      try {
        document.execCommand('copy');
        done();
      } catch (e) {}
    }
  }

  /* ------------------------------------------------------------------ */
  /* Wire up                                                            */
  /* ------------------------------------------------------------------ */

  openBtn.setAttribute('aria-expanded', 'false');
  openBtn.addEventListener('click', openModal);

  dismissBtn.addEventListener('click', function (event) {
    event.stopPropagation();
    storageSet(STORAGE_DISMISSED, String(Date.now() + dismissDays * 86400000));
    hideLauncher();
  });

  root.querySelectorAll('[data-jw-gift-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  form.addEventListener('submit', onSubmit);
  emailInput.addEventListener('input', function () {
    if (emailInput.getAttribute('aria-invalid') === 'true') {
      emailInput.removeAttribute('aria-invalid');
      setStatus('');
    }
  });
  if (copyBtn) copyBtn.addEventListener('click', onCopy);

  if (!isSuppressed()) window.setTimeout(showLauncher, SHOW_DELAY_MS);
})();
